const API_BASE = process.env.REACT_APP_API_URI || 'https://api.acc.inframent.com';

export default async function (setLoading, navigate, setUser) {
  setLoading(true);
  const token = localStorage.getItem('authToken');

  if (!token) {
    if (setLoading) setLoading(false);
    if (setUser) setUser(null);
    if (navigate) navigate('/auth/sign-in');
    return;
  }

  try {
    const response = await fetch(`${API_BASE}/profile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      if (navigate) navigate('/projects');
      if (setUser) setUser(token);
    } else {
      localStorage.removeItem('authToken');
      if (setUser) setUser(null);
      if (navigate) navigate('/auth/sign-in');
    }
  } catch {
    localStorage.removeItem('authToken');
    if (setUser) setUser(null);
    if (navigate) navigate('/auth/sign-in');
  } finally {
    if (setLoading) setLoading(false);
  }
}
